import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=35b1adfb&scoped=true&"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeEmbed.vue?vue&type=style&index=0&id=35b1adfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1adfb",
  null
  
)

export default component.exports